import React from 'react'
import PropTypes from 'prop-types'
import { CustomSelect, EditFieldsDialog } from '@components/common'
import { move } from 'ramda'

export class EditPropertyDetails extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      dialogPropertyFields: {
        propertyFields: [],
        mandatoryFields: [],
        allFields: [],
        dragIndex: -1
      },
      disclaimerForm: false,
      showDisclaimer: false,
      disclaimerText: ''
    }
  }

  componentDidMount() {
    this.setState({
      dialogPropertyFields: {
        ...this.state.dialogPropertyFields,
        ...this.props.dialogProperties
      },
      showDisclaimer: this.props.summaryDisclaimerText?.showDisclaimer || false,
      disclaimerText: this.props.summaryDisclaimerText?.disclaimerText || ''
    })
  }

  savePropertyDetails = () => {
    this.props.closeEditPopup()
    const payloadData = {
      propertyFields: this.state.dialogPropertyFields.propertyFields,
      disclaimerTextData: { showDisclaimer: this.state.showDisclaimer, disclaimerText: this.state.disclaimerText }
    }
    this.props.doneDialog(payloadData)
  }

  handleReset = () => {
    this.setState({
      dialogPropertyFields: {
        ...this.state.dialogPropertyFields,
        ...this.props.dialogProperties
      },
      showDisclaimer: this.props.summaryDisclaimerText?.showDisclaimer || false,
      disclaimerText: this.props.summaryDisclaimerText?.disclaimerText || ''
    })
  }

  handleClose = () => {
    this.props.closeEditPopup()
    this.handleReset()
  }

  handleSelectChange = (position, event) => {
    const { value } = event.target
    const displayFields = this.state.dialogPropertyFields.propertyFields.map((item, i) => {
      if (i === position) {
        let propetyLabel = this.state.dialogPropertyFields.allFields.filter(field => field.value === value)
        if (propetyLabel.length === 0) {
          propetyLabel = [{ key: 'NA', value: 'NA' }]
        }

        return propetyLabel[0]
      }

      return item
    })

    this.setState({
      dialogPropertyFields: {
        ...this.state.dialogPropertyFields,
        propertyFields: displayFields
      }
    })
  }

  onDragOver = () => e => {
    e.preventDefault()
  }

  onDragStart = originalIndex => () => {
    this.setState({
      dialogPropertyFields: {
        ...this.state.dialogPropertyFields,
        dragIndex: originalIndex
      }
    })
  }

  reArrangePropertyFields(indexFrom, indexTo) {
    const reArrangedPropertyFields = move(indexFrom, indexTo, this.state.dialogPropertyFields.propertyFields)
    this.setState({
      dialogPropertyFields: {
        ...this.state.dialogPropertyFields,
        propertyFields: reArrangedPropertyFields
      }
    })
  }

  onDrop = orderIndex => e => {
    e.preventDefault()
    if (orderIndex === this.state.dialogPropertyFields.dragIndex) {
      return
    }
    this.reArrangePropertyFields(this.state.dialogPropertyFields.dragIndex, orderIndex)
  }

  editDisclaimerText = () => {
    if (!this.state.disclaimerForm) {
      this.setState({
        disclaimerForm: true
      })
    }
  }

  updateDisclaimerText = event => {
    event.preventDefault()
    this.setState({
      disclaimerForm: false,
      disclaimerText: event.target.disclaimerText.value
    })
  }

  cancelDisclaimerText = () => {
    this.setState({
      disclaimerForm: false,
      disclaimerText: this.props.summaryDisclaimerText.disclaimerText
    })
  }

  handleShowDisclaimer = () => {
    this.setState({
      showDisclaimer: !this.state.showDisclaimer
    })
  }

  render() {
    const { isDialogOpen, contentNote, dialogTitle, isDisclaimerNeeded = false } = this.props
    const propFieldKeys = this.state.dialogPropertyFields.propertyFields.map(prop => prop.value)
    const availableFieldsForSelection = this.state.dialogPropertyFields.allFields.filter(item => !propFieldKeys.includes(item.value))
    const { dragIndex, propertyFields } = this.state.dialogPropertyFields

    return (
      <EditFieldsDialog
        isDialogOpen={isDialogOpen}
        contentNote={contentNote}
        dialogTitle={dialogTitle}
        handleClose={this.handleClose}
        handleReset={this.handleReset}
        savePropertyDetails={this.savePropertyDetails}
        disclaimerForm={this.state.disclaimerForm}
        disclaimerText={this.state.disclaimerText}
        updateDisclaimerText={this.updateDisclaimerText}
        cancelDisclaimerText={this.cancelDisclaimerText}
        showDisclaimer={this.state.showDisclaimer}
        handleShowDisclaimer={this.handleShowDisclaimer}
        editDisclaimerText={this.editDisclaimerText}
        isDisclaimerNeeded={isDisclaimerNeeded}
      >
        {propertyFields.map((propertyField, index) => (
          <CustomSelect
            key={index}
            position={index}
            propertyField={propertyField}
            isMandatoryField={this.state.dialogPropertyFields.mandatoryFields.includes(propertyField.value)}
            availableFieldsForSelection={availableFieldsForSelection}
            handleSelectChange={this.handleSelectChange}
            isDragging={dragIndex === index}
            dragMode={dragIndex !== -1}
            onDragOver={this.onDragOver}
            onDragStart={this.onDragStart}
            onDrop={this.onDrop}
          />
        ))}
      </EditFieldsDialog>
    )
  }
}

EditPropertyDetails.propTypes = {
  closeEditPopup: PropTypes.func,
  isDialogOpen: PropTypes.bool,
  doneDialog: PropTypes.func,
  dialogProperties: PropTypes.object,
  contentNote: PropTypes.string,
  dialogTitle: PropTypes.string,
  summaryDisclaimerText: PropTypes.object,
  isDisclaimerNeeded: PropTypes.bool
}

export default EditPropertyDetails
